SA.Promise = {
    createQueued(fn) {
        var promise = Promise.resolve();

        return function(...args) {
            promise = promise.finally(() => fn.apply(this, args));

            return promise;
        };
    },

    delay(milliseconds) {
        return new Promise(resolve => setTimeout(resolve, milliseconds));
    },

    unresolving() {
        return new Promise(() => {});
    }
};